import { render, staticRenderFns } from "./alignself.vue?vue&type=template&id=fe2e7b5a&lang=pug&"
import script from "./alignself.vue?vue&type=script&lang=js&"
export * from "./alignself.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('fe2e7b5a', component.options)
    } else {
      api.reload('fe2e7b5a', component.options)
    }
    module.hot.accept("./alignself.vue?vue&type=template&id=fe2e7b5a&lang=pug&", function () {
      api.rerender('fe2e7b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form_element/alignself.vue"
export default component.exports